module.exports = __webpack_public_path__ + "static/media/elo.5e8dbfbd.png";